// Redux Toolkit Hooks and Slices
import { closeModal } from "../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";

// Custom Hooks
import { useModalSelector } from "../../../../hooks/useModalSelector";
import useCCNames from "../../../../hooks/useCCNames";

// Constants and Utilities
import { AttendanceCorrection } from "../../../../utils/Constant";

// Components
import CommonModal from "../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import AttendanceCorrectionForm from "../form/AttendanceCorrectionForm";

// Types
import { IAttendanceEditModalProps } from "../../types";

const AttendanceCorrectionModal = ({
  endDate,
  dispatch,
  startDate,
  financialYear,
  findMatchedAttendance,
  onCorrectionSuccess,
}: IAttendanceEditModalProps) => {
  const { isOpen } = useModalSelector();
  const { ccNames, toMailNames, clearCCNames, clearToMailNames } = useCCNames();

  const handleCloseModal = (): void => {
    clearCCNames();
    clearToMailNames();
    dispatch(closeModal());
  };

  return (
    <CommonModal
      modalClassName="attendance-correction-dialog"
      contentClassName="attendance-correction-modal"
      headerClassName="attendance-correction-header"
      titleClassName="text-white"
      title={AttendanceCorrection}
      modalBodyClassName="p-0"
      centered
      fade={true}
      toggle={handleCloseModal}
      isOpen={isOpen}
      showFooter={false}
    >
      {findMatchedAttendance && ccNames && toMailNames && (
        <div className="modal-toggle-wrapper">
          <AttendanceCorrectionForm
            endDate={endDate}
            ccNames={ccNames}
            dispatch={dispatch}
            startDate={startDate}
            toNames={toMailNames}
            clearCCNames={clearCCNames}
            clearToNames={clearToMailNames}
            activeYear={Number(financialYear)}
            attendance={findMatchedAttendance}
            onCorrectionSuccess={onCorrectionSuccess}
          />
        </div>
      )}
    </CommonModal>
  );
};

export default AttendanceCorrectionModal;
